// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responsive-flex {
  display: flex;
  justify-content: space-evenly;
}
.responsive-flex button {
  margin: 3px 3px;
}

a {
  color: #30be5f;
}

a:hover {
  text-shadow: -0.06ex 0 #30be5f, 0.06ex 0 #30be5f;
}

.links-wrapper {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .responsive-flex {
    display: block;
  }
  .responsive-flex button {
    max-width: 82vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnZlcnNpb24tZGV0YWlscy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSw2QkFBQTtBQUNGO0FBQUU7RUFDRSxlQUFBO0FBRUo7O0FBRUE7RUFDRSxjQUFBO0FBQ0Y7O0FBQ0E7RUFDRSxnREFDRTtBQUNKOztBQUVBO0VBQ0UsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFO0lBQ0UsY0FBQTtFQUNGO0VBQ0U7SUFDRSxlQUFBO0lBQ0EsZ0JBQUE7SUFDQSx1QkFBQTtFQUNKO0FBQ0YiLCJmaWxlIjoiY29udmVyc2lvbi1kZXRhaWxzLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnJlc3BvbnNpdmUtZmxleCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtZXZlbmx5O1xuICBidXR0b24ge1xuICAgIG1hcmdpbjogM3B4IDNweDtcbiAgfVxufVxuXG5hIHtcbiAgY29sb3I6ICMzMGJlNWY7XG59XG5hOmhvdmVyIHtcbiAgdGV4dC1zaGFkb3c6XG4gICAgLTAuMDZleCAwICMzMGJlNWYsXG4gICAgMC4wNmV4IDAgIzMwYmU1Zjtcbn1cbi5saW5rcy13cmFwcGVyIHtcbiAgbWFyZ2luLXRvcDogMTBweDtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5yZXNwb25zaXZlLWZsZXgge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuXG4gICAgYnV0dG9uIHtcbiAgICAgIG1heC13aWR0aDogODJ2dztcbiAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICB9XG4gIH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/ui/conversion-details/conversion-details.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;AACF;AAAE;EACE,eAAA;AAEJ;;AAEA;EACE,cAAA;AACF;;AACA;EACE,gDACE;AACJ;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;IACE,cAAA;EACF;EACE;IACE,eAAA;IACA,gBAAA;IACA,uBAAA;EACJ;AACF;AACA,glCAAglC","sourcesContent":[".responsive-flex {\n  display: flex;\n  justify-content: space-evenly;\n  button {\n    margin: 3px 3px;\n  }\n}\n\na {\n  color: #30be5f;\n}\na:hover {\n  text-shadow:\n    -0.06ex 0 #30be5f,\n    0.06ex 0 #30be5f;\n}\n.links-wrapper {\n  margin-top: 10px;\n}\n\n@media (max-width: 768px) {\n  .responsive-flex {\n    display: block;\n\n    button {\n      max-width: 82vw;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
